
import BaseView from "@core/View.js";
import { $util } from "@util/util.js";
import renderLetteringPopup  from '@/vue/pc/bizComponents/Lettering/index.js';
import { cloneDeep } from 'lodash-es';
import usePrivateStore from "@shared/store/usePrivateStore";
import { toast } from '@shared/utils/biz_utils';
import API from "@api/index.js";


export default class CTOView extends BaseView {
    constructor(model) {
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._extraBoxEl;
    }
    AcItemReturn(item) {
        return `<span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock == 0) ? '0.5' : '1'}" class="fl e_goods_imgs">
            <a target="_blank" href="${this._model._parent._link}">${!!item?._pturl ? `<img src=${item._pturl} />` : ''}</a>
        </span>`
    }
    _priceShow(item) {
        if (item._price) {
            return '¥'
        } else {
            return ''
        }
    }
    _priceShows(item) {
        if (item._xiaoji) {
            return '¥'
        } else {
            return ''
        }
    }
    getItems() {
        let html = "";
        this._model._items.forEach((item, idx) => {
            const isA = item._ptside.toUpperCase() == 'A';

            html += `<div class="clearfix right_item">
                    <div class="fl e_goods">
                        ${this.AcItemReturn(item)}
                        <span class="fl e_goods_desc lenovo-emoji" >
                            <a target="_blank"style="opacity:${(this._model._parent._invalid || 
                              item._invalid || 
                              !this._model._parent._marketable || 
                              this._model._parent._stock <= 0) ? '0.5' : '1'}" href="${this._model._parent._link}" class="${this.getInvalidInfo().cls}">  
                              ${this.getPtsideMsgAndPtWord(item)}
                              </a>
                            ${this.getInvalidInfo(item).msg ? '<span class="le_tip_btn_solid">' + this.getInvalidInfo(item).msg + '</span>' : ''}
                        </span>
                    </div>
                    <div class="fl le_width_172  e_price" style="height: 20px"><p class="le_paddingl_65" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? '0.5' : '1'}"> ${this._priceShow(item)}${item._price}</p></div>
                    <div class="fl le_width_172 e_quantity" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? '0.5' : '1'}">${item._num}</div>
                    <div class="fl le_width_172 e_sum" style="height: 20px"><p class="le_paddingl_65" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0) ? '0.5' : '1'}"> ${this._priceShows(item)}${item._xiaoji}</p></div>
                    <div class="fl le_width_116 e_action"><p class="le_paddingl_26" tag='onClickCTo' latag="latag_pc_购物车_私人定制${isA ? 'A面' : 'C面'}_0_null_重选" style="display:${!this._model._parent._invalid ? "block" : "none"};" code="${item._parent._parent._id}" _ptside="${item._ptside}">重选</p></div>
                </div>`;
        });
        return html;
    }
    
    getPtsideMsgAndPtWord(item) {
      let htmlStr = '';
      if(item?._picName){
        htmlStr += `<b>${item._ptsideMsg}</b> `;
        htmlStr += item._picName;
      }else{
        if(item?._ttfUrl && item?._fontName){
          let fontFamily = `personal-font-${item._fontId}`;
          const style = document.createElement('style');
          style.textContent = `
              @font-face {
                  font-family: '${fontFamily}';
                  src: url('${item._ttfUrl}') format('truetype');
              }
          `;
          document.head.appendChild(style);
          htmlStr += `<span style="font-family: '${fontFamily}', 'lenovo-emoji'">${item._fontName}</span> `;
          htmlStr += `<span class="carveContent" style="font-family: '${fontFamily}', 'lenovo-emoji'">${item._ptword}</span>`;
        }else{
          htmlStr += `<b>${item._ptsideMsg}</b> `;
          htmlStr += `<span class="carveContent" style="font-family: 'lenovo-emoji'">${item._ptword}</span>`;
        }
      }
      return htmlStr;
    }

    render() {
        let html = "";
        html += `
            <div class="clearfix extra_item custom ${this.getInvalidInfo().cls}">
                <div class="fl e_name extra_item_left">私人定制</div>
                <div class="fl extra_item_middle">
                    ${this.getItems()}
                </div>
            </div>`;
        $(this._parentEl).append($(html));
        this._el = $("div.extra_item_middle");
        this.regEvent()
    }
    regEvent() {
        let that = this;
        this._parentEl.off("click", "p[tag='onClickCTo']").on("click", "p[tag='onClickCTo']", function () {
            let _ptside = $(this).attr('_ptside')
            let code = $(this).attr('code')
            let params = {
                code: code
            }
            if (_ptside == "A") {
                const materialCode = that._model._parent._data && that._model._parent._data.materialCode;
                $('.pc_mask').show();
                $util.toggleBodyScroller(true);
                that._model._parent.getPersonalGoods(params).then((res) => {
                    $('.personal_img').show();
                    let personalizations = that._model._parent._data.personalizations
                    let indexs = 0
                    let datas = ''
                    personalizations.map((item, index) => {
                        if (item.ptside == 'A') {
                            datas = item
                        }
                    })
                    that._model._parent.getPersonalPicturess({ code: datas.ptcode }).then(x => {
                        that._model._parent._personalGoods.aPriceCode = datas.ptcode
                        // console.log(x,'xxxxxxxxxxxxxxxxxxxxxxxx');
                        if (personalizations && personalizations.length > 0) {
                            let data = that._model._parent._personalGoods
                            data._aSideData.map((item, index) => {
                                if (item.code == datas.ptcode) {
                                    indexs = index
                                }
                            })
                        }
                        that._model._parent._personalGoods._view.render('A', indexs, '', materialCode)

                    }).catch(err => {
                        that._model._parent._personalGoods._view.render('A', indexs, '', materialCode)
                    })

                }).catch(err => {
                    // position 接口返回 404（未配置有效私定数据）：关闭遮罩，toast 接口文案，不展示兜底框
                    if (err?.code == 404) {
                        $('.pc_mask').hide();
                        $util.toggleBodyScroller(false);
                        toast(err?.msg || '未配置有效私定数据');
                        return;
                    }
                    $('div.personal_boxs').show();
                    $("[tag='presonalCText']").html(`<i class="fr iconfont icon-close close_personal" tag="presonalCancel"></i>A面私人定制信息`)
                });

            } else if(_ptside == "C"){
                that._model._parent.getPersonalGoods(params).then((res) => {
                    // 校验：position 接口 machineInfo.mobileList 中若每个对象的 tabTitle 都为空，则该商品不支持私定刻字
                    const mobileList = that._model._parent._personalGoods?.machineInfo?.mobileList || [];
                    const hasTab = mobileList.some(item => item?.tabTitle);
                    if (!hasTab) {
                        toast('该商品暂不支持私定刻字，请重新下单');
                        return;
                    }
                    const carveContentDom = $(this.parentElement.parentElement).find('.carveContent')
                    that._model._parent._personalGoods.cPTword = carveContentDom.text()
                    if (that._model._parent._personalGoods._cSideData.length > 0) {
                        $('.personal_text').show()
                        $('.pc_mask').show();
                        $util.toggleBodyScroller(true);
                        that._model._parent._personalGoods._view.render('C', 0);
                        
                    } else {
                        $("[tag='presonalCText']").html(`<i class="fr iconfont icon-close close_personal" tag="presonalCancel"></i>C面私人定制信息`)
                        $('.personal_boxs').show()
                        $('.pc_mask').show();
                        $util.toggleBodyScroller(true);
                    }
                }).catch(err => {
                    // position 接口返回 404（未配置有效私定数据）：toast 接口文案
                    if (err?.code == 404) {
                        toast(err?.msg || '未配置有效私定数据');
                        return;
                    }
                    // $("[tag='presonalCText']").html(`<i class="fr iconfont icon-close close_personal" tag="presonalCancel"></i>C面私人定制信息`)
                    // $('.personal_boxs').show()
                    // $('.pc_mask').show();
                    // $util.toggleBodyScroller(true);
                });
            } else if(_ptside == "L"){
              const materialCode = that._model._parent._data && that._model._parent._data.materialCode;
              $('.pc_mask').show();
              $util.toggleBodyScroller(true);
              that._model._parent.getPersonalGoods(params).then((res) => {
                  $('.personal_img').show();
                  let personalizations = that._model._parent._data.personalizations
                  let indexs = 0
                  let datas = ''
                  personalizations.map((item, index) => {
                      if (item.ptside == 'L') {
                          datas = item
                      }
                  })
                  that._model._parent.getPersonalPicturess({ code: datas.ptcode }).then(x => {
                      that._model._parent._personalGoods.aPriceCode = datas.ptcode
                      // console.log(x,'xxxxxxxxxxxxxxxxxxxxxxxx');
                      if (personalizations && personalizations.length > 0) {
                          let data = that._model._parent._personalGoods
                          data._aSideData.map((item, index) => {
                              if (item.code == datas.ptcode) {
                                  indexs = index
                              }
                          })
                      }
                      that._model._parent._personalGoods._view.render('L', indexs, '', materialCode)

                  }).catch(err => {
                      that._model._parent._personalGoods._view.render('A', indexs, '', materialCode)
                  })

              }).catch(err => {
                  // position 接口返回 404（未配置有效私定数据）：关闭遮罩，toast 接口文案，不展示兜底框
                  if (err?.code == 404) {
                      $('.pc_mask').hide();
                      $util.toggleBodyScroller(false);
                      toast(err?.msg || '未配置有效私定数据');
                      return;
                  }
                  $('div.personal_boxs').show();
                  $("[tag='presonalCText']").html(`<i class="fr iconfont icon-close close_personal" tag="presonalCancel"></i>A面私人定制信息`)
              });
            } else if(_ptside == "Z"){
              let personalizations = that._model._parent._data.personalizations;
              API.getPersonalGoods(params).then((res) => {
                // 校验：position 接口 machineInfo.mobileList 中若每个对象的 tabTitle 都为空，则该商品不支持私定刻字
                const mobileList = res?.t?.machineInfo?.mobileList || [];
                const hasTab = mobileList.some(item => item?.tabTitle);
                if (!hasTab) {
                  toast('该商品暂不支持私定刻字，请重新下单');
                  return;
                }
                // 存入当前点击的商品id
                usePrivateStore().setCurrentClickProductCode(cloneDeep(params));
                usePrivateStore().setPrivateInfo(personalizations[0]);
                usePrivateStore().setCurrentClickProduct(that._model._parent._data);
                try{
                  const div = document.createElement('div');
                  const id ='popUp_'+ Math.floor(Math.random() * 10000);
                  div.id = id;
                  div.classList.add('cart_item_lettering_popup');
                  document.body.append(div);
                  renderLetteringPopup(`#${id}`);
                } catch(err){
                  console.log('popup catch', err);
                }
              }).catch((err) => {
                // position 接口返回 404（未配置有效私定数据）：toast 接口文案，不打开弹层
                if (err?.code == 404) {
                  toast(err?.msg || '未配置有效私定数据');
                  return;
                }
                console.log('getPersonalGoods catch', err);
              });
            }

        })
        $('.personal_boxs').off("click", "[tag='presonalCancel']").on("click", "[tag='presonalCancel']", function () {
            $('.personal_box').hide();
            $('.personal_boxs').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);

        })


    }
}